export default {
  appTitle: 'RCM',
  rcmGrid: {
    invoiceNumber: 'No. de factura',
    healthcarePlanCoverage: 'PBS',
    patientId:'Id de paciente',
    eventNumber: 'Evento',
    eventDate: 'Fecha de evento',
    payerName: 'Pagador',
		agreementName: 'Convenio',
    invoiceAmount: 'Valor de cuenta ({currency})',
    suffix: '$',
    requiredSupportDocumentsCompleted: 'Documentación',
    agreementCode: 'Id de convenio',
    status: 'Estado',
    serviceTypes: 'Tipo de evento',
    regime: 'Régimen',
    responsible: 'Responsable',
    costCenter: 'Centro de costos',
    settlementGroupId: 'Relación de envío',
  },
  rcmGridItems: {
    defaultStatus: {
      pending: 'PENDIENTE'
    }
  },
  rcmGridTooltips: {
    multiples: 'Múltiples',
    reassignedAccount: 'Cuenta refacturada'
  },
  documentationStatus: {
    complete: 'Completa',
    incomplete: 'Incompleta',
    ripAndCuvFilesIncomplete: 'Archivos RIP y CUV incompletos',
  },
  filters: {
    searchCode: 'Buscar por No. de factura, Evento, Id de convenio, Régimen o Id de paciente',
    invoiceNumberStatus: 'Estado',
    statusHealthcarePlanCoverage: 'PBS / NPBS',
    statusDocumentation: 'Documentación',
    payer: 'Pagador',
		agreement: 'Convenio',
    minAmount: 'Monto min.',
    maxAmount: 'Monto max.',
    from: 'Desde',
    to: 'Hasta',
    concurrent: 'Concurrente',
    serviceType: 'Tipo de evento',
    seeMoreFilters: 'Ver más filtros',
    executorServices: 'Especialidad',
    agreementPlanTypes: 'Tipo de plan',
    invoiceSource: 'Fuente de factura',
    applyFilters: 'Aplicar filtros',
    currency: 'COP',
    missingSupports: 'Documentos faltantes',
    noResultsFound: 'No se encontraron resultados',
    responsibleAssigned: 'Responsable asignado',
    reassignedAccount: 'Refacturación',
  },
  resultLabel: {
    text: 'Resultados',
    result: '({result})'
  },
  actionLabel: {
    text: 'Acciones',
    selected: '({selected})'
  },
  accountsActions: {
    moveToReadyToSettlement: 'Mover a listas para radicar',
    moveToSent: 'Mover a enviados',
    moveToSettled: 'Mover a radicados',
    disableAccounts: 'Deshabilitar cuentas',
    assignResponsible: 'Asignar responsable',
    cleanPackageFolder: 'Eliminar carpetas FileZilla',
  },
  homeConfirmationDialog: {
    disableAccounts: {
    title: "¿Estás seguro que quieres deshabilitar las cuentas seleccionadas?",
    subtitle: "Agrega un motivo para deshabilitar las cuentas (opcional)",
    },
    moveToSettled: {
      title: "¿Estás seguro que quieres mover a radicadas las cuentas seleccionadas?",
      subtitle: "",
    },
    moveToSent: {
      title: "¿Estás seguro que quieres mover a enviado las cuentas seleccionadas?",
      subtitle: ""
    },
    moveToPackageGenerated: {
      title: "¿Estás seguro que quieres mover a lista para radicar las cuentas seleccionadas?",
      subtitle: ""
    },
    assignResponsible: {
      title: "Asignar responsable",
      subtitle: "Selecciona un responsable para las cuentas seleccionadas",
      label: "Responsable",
    },
    cleanPackageFolder: {
      title: "¿Estás seguro que deseas eliminar las carpetas de FileZilla?",
      subtitle: "",
    },
  },
  filtersText: {
    statusAccounts: {
      inProgress: 'En progreso',
      invoiced: 'Facturada',
      readyToGenerate: 'Lista para generar',
      packageGenerated: 'Lista para radicar',
      pendingAudit: 'Auditoria pendiente',
      voided: 'Deshabilitado',
      error: 'Error',
      completeAudit: 'Auditoria completada',
      sent: 'Enviado',
      settled: 'Radicada',
      preInvoiced: 'Pre facturada'
    },
    statusHealthcarePlanCoverage: {
      pos: 'PBS',
      notPos: 'NPBS',
      posNoPos: 'PBS / NPBS'
    },
    statusDocumentation: {
      completed: 'Completa',
      incomplete: 'Incompleta'
    },
    statusPayers: {
      nuevaEps: 'Nueva EPS'
    },
    reassignedAccount: {
      reassigned: 'Cuentas refacturadas'
    },
    statusConcurrent: 'Cuenta concurrente',
    mobileHeader: 'Filtros'
  },
  drawer: {
    labels: {
      accounts: 'Cuentas',
      agreements: 'Convenios',
      preSettlement: 'Relación de envío',
      pmisConfig: 'Configuración PMIS',
      uploadAgreement: 'Carga de convenios'
    },
    addOns: {
      accounts: {
        title: 'Listado de cuentas',
        placeholder: 'Buscar por ID',
        createdAt: 'Fecha de creación',
        stateAccount: 'Estado',
        invoiceNumber: 'No. de cuenta',
        healthcarePlanCoverage: 'PBS / NPBS',
        totalInvoiceAmount: 'No. de cuenta',
        agreement: 'Convenio',
        locationName: 'Sede'
      }
    }
  },
  accountDetail: {
    generalInformation: {
      titlesGeneralInformation: {
        patientName: 'Paciente',
        patientId: 'ID Paciente',
        patientDocumentType: 'Tipo de identificación',
        patientDocumentNumber: 'No. de identificación',
        eventNumber: 'Evento',
        eventDate: 'Fecha de evento',
        serviceType: 'Tipo de evento',
        insurer: 'Convenio',
        originInvoiceGroupId: 'Relación de envío',
        settlementNumber: 'ID de radicación',
        externalId: 'Guia',
        authorizationId: 'ID de autorización',
        regime: 'Régimen',
        agreementPlanType: 'Tipo de plan',
        invoiceSource: 'Fuente de factura',
        invoiceNumber: 'No. de factura',
        invoiceDate: 'Fecha de factura',
        invoiceBranch: 'Sede de factura',
        createdAt: 'Fecha de creación cuenta',
        stateAccount: 'Estado',
        agreement: 'Código de convenio',
        healthcarePlanCoverage: 'PBS / NPBS',
        invoiceAmountTotal: 'Valor total',
        responsible: 'Responsable',
        reassignedInvoiceNumber: 'Cuenta origen refacturación',
      },
      defaultInformation: {
        defaultRegime: 'EPS',
        defaultInvoiceAmount: 'Pendiente',
        defaultHealthCarePlanCoverage: 'PBS / NPBS'
      }
    }
  },
  chargeDetail: {
    patientInformation: {
      patientName: 'Paciente',
      patientId: 'ID paciente',
      eventNumber: 'Evento',
      patientDocumentType: 'Tipo de identificación',
      patientDocumentNumber: 'No. de identificación'
    },
    chargeDetail: {
      createdAt: 'Fecha de creación',
      healthcarePlanCoverage: 'PBS / NPBS',
      chargeCode: 'Código de cargo',
      authorizationId: 'Número de convenio',
      invoiceable: 'Facturable',
      payer: 'Aseguradora',
      location: 'Sede',
      typeOfService: 'Tipo de servicio',
      quantity: 'Cantidad',
      invoiceNumber: 'No. de factura',
      unitValue: 'Valor unitario',
      totalAmount: 'Valor total'
    },
    defaultInformation: {
      defaultInvoiceAmount: 'Pendiente',
    },
    diagnosticTable: {
      diagnosticCode: 'Código de diagnóstico',
      descriptionDiagnosis: 'Descripción de diagnóstico',
      chargeDescription: 'Descripción del cargo'
    }
  },
  amounts: {
    ruleMessage: 'Solo se permiten números positivos',
    minAmount: 'Min. {currency} {amount}',
    maxAmount: 'Max. {currency} {amount}',
  },
  auditComplete: 'La auditoría se ha completado exitosamente',
  setReadyToGenerate: 'La cuenta se ha marcado como lista para generar',
  setReadyToGenerateMultiple: 'La cuenta de la factura se ha marcado como lista para generar. Este proceso puede tardar unos minutos; por favor, espere. | Las cuentas de las facturas se han marcado como listas para generar. Este proceso puede tardar unos minutos; por favor, espere.',
  setPreSettlementActionMultiple: 'La cuenta de la factura se ha puesto en cola para procesar. Este proceso puede tardar unos minutos; por favor, espere. | Las cuentas de las facturas se han puesto en cola para procesar. Este proceso puede tardar unos minutos; por favor, espere.',
  setPreSettlementRipsValidationErrors: 'La relación de envío se han marcado con el estado de error en validación de archivos RIPS.',
  setDisableAccounts: 'Las cuentas se han deshabilitado exitosamente',
  movedToSettlement: 'Las cuentas se han puesto en cola para procesar. Este proceso puede tardar unos minutos; por favor, espere.',
  assignResponsible: 'El responsable se ha asignado exitosamente',
  accountsAffected: 'Cuentas afectadas',
  lastUpdate: 'Última actualización',
  errorLoadindServiceTypes: 'Error al obtener los tipos de servicio del proveedor.',
	errorLoadindAgreements: 'Error al obtener los convenios del proveedor.',
  errorLoadindProviderSupportDocuments: 'Error al obtener los documentos de soporte del proveedor.',
  errorLoadindUsers: 'Error al obtener los usuarios.',
  cleanPackageFolder: 'La carpeta de FileZilla se ha eliminado exitosamente',
	validateAccountNotifications: {
		filter: 'Revalidar cuentas',
		inProgressWording: 'cuentas seleccionadas',
		completedWording: 'cuentas',
		errorWording: 'cuentas por favor, volver a intentar.',
		status: {
			started: 'Iniciado',
			inProgress: 'En progreso',
			completed: 'Completados',
			error: 'Error'
		}
	}
}
